// src/hooks/useNavigationHistory.js - CORRECCIÓN
import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

/**
 * Hook personalizado para gestionar la navegación con soporte mejorado para "volver atrás"
 * ✅ SIMPLIFICADO: No duplicamos la gestión de filtros que ya existe en useColumnFilter
 */
export const useNavigationHistory = () => {
  const navigate = useNavigate();
  const location = useLocation();

  /**
   * Función para navegar hacia atrás de manera inteligente
   * @param {string} defaultRoute - Ruta por defecto si no hay historial
   */
  const goBack = useCallback((defaultRoute = '/') => {
    // Primero comprobar si hay una ruta guardada en sessionStorage
    const savedRoute = sessionStorage.getItem('returnToRoute');
    
    if (savedRoute) {
      // Limpiar la ruta guardada para no usarla más
      sessionStorage.removeItem('returnToRoute');
      
      // Navegar a la ruta guardada
      navigate(savedRoute);
    } else if (window.history.length > 1) { // ✅ CORREGIDO: Cambiado de > 2 a > 1
      // Si hay historial, ir atrás
      navigate(-1);
    } else {
      // Si no hay historial, ir a la ruta por defecto
      navigate(defaultRoute);
    }
  }, [navigate]);

  /**
   * Guardar la ruta actual para volver después
   * @param {string} targetRoute - Ruta a la que se va a navegar
   */
  const saveCurrentRoute = useCallback((targetRoute) => {
    sessionStorage.setItem('returnToRoute', location.pathname);
    navigate(targetRoute);
  }, [navigate, location]);

  /**
   * ✅ NUEVA: Función para verificar si hay filtros activos en una ruta específica
   * Reutiliza el sistema existente de useColumnFilter
   * @param {string} route - Ruta a verificar (ej: '/works')
   * @returns {Object} - Información sobre filtros
   */
  const getFilterInfo = useCallback((route) => {
    if (route === '/works') {
      try {
        let activeFiltersCount = 0;
        let showFinalized = false;
        
        // ✅ REUTILIZAR las claves existentes de useColumnFilter
        // Contar filtros activos usando el mismo patrón que useColumnFilter
        for (let i = 0; i < sessionStorage.length; i++) {
          const key = sessionStorage.key(i);
          if (key && key.startsWith('filter-works-list-')) {
            const filters = JSON.parse(sessionStorage.getItem(key) || '[]');
            activeFiltersCount += filters.length;
          }
        }
        
        // ✅ VERIFICAR el estado específico de showFinalized
        const showFinalizedState = sessionStorage.getItem('works-list-showFinalized');
        if (showFinalizedState) {
          showFinalized = JSON.parse(showFinalizedState);
        }
        
        return {
          hasFilters: activeFiltersCount > 0 || showFinalized,
          activeFiltersCount,
          showFinalized
        };
      } catch (error) {
        console.error('Error al obtener información de filtros:', error);
        return { hasFilters: false, activeFiltersCount: 0, showFinalized: false };
      }
    }
    
    return { hasFilters: false, activeFiltersCount: 0 };
  }, []);

  return {
    goBack,
    saveCurrentRoute,
    getFilterInfo
  };
};

export default useNavigationHistory;